import { OrganizationType } from '../../core/data-models/organization-type.model';

/**
 * Display labels for each OrganizationType.  Typed as a full Record so adding
 * a new enum member fails to compile until it has a label.
 */
export const ORGANIZATION_TYPE_LABELS: Record<OrganizationType, string> = {
  [OrganizationType.Individual]: 'Individual',
  [OrganizationType.Llc]: 'LLC',
  [OrganizationType.SCorp]: 'S-Corp',
  [OrganizationType.CCorp]: 'C-Corp',
  [OrganizationType.Partnership]: 'Partnership',
  [OrganizationType.SoleProprietorship]: 'Sole Proprietorship',
  [OrganizationType.NonProfit]: 'Non-Profit',
  [OrganizationType.Other]: 'Other',
};

/**
 * Dropdown options for organization type selects
 */
export const ORGANIZATION_TYPE_OPTIONS: { value: OrganizationType; label: string }[] =
  Object.values(OrganizationType).map(value => ({ value, label: ORGANIZATION_TYPE_LABELS[value] }));
